import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';
import { Layout, PageHeader, Table, Select, AutoComplete, Button, Input, List, Divider, Spin, Icon, DatePicker, Modal, message } from 'antd';
import moment from 'moment';

import BacktestResult from './BacktestResult';

import emitter from '../Evt.js';

var moment_timezone = require('moment-timezone');

const { Sider, Content } = Layout;
const Option = Select.Option;
const Confirm = Modal.confirm;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const selRateOfReturn = [
    { 'id': '0', 'name': languageMessages['all'] },
    { 'id': '1', 'name': '0~10%' },
    { 'id': '2', 'name': '11%~20%' },
    { 'id': '3', 'name': '21%~30%' },
    { 'id': '4', 'name': '31%~40%' },
    { 'id': '5', 'name': '41%~50%' },
    { 'id': '6', 'name': strReplace(languageMessages['theAbove'], { '{num}': '50%' }) },
    { 'id': '7', 'name': '-10%~0' },
    { 'id': '8', 'name': '-20%~-11%' },
    { 'id': '9', 'name': '-30%~-21%' },
    { 'id': '10', 'name': '-40%~-31%' },
    { 'id': '11', 'name': '-50%~-41%' },
    { 'id': '12', 'name': strReplace(languageMessages['theFollowing'], { '{num}': '-50%' }) }
];

var format = 'YYYY-MM-DD HH:mm:ss';
class MyBacktestPage extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.user = {};
        this.state = {
            keywords: '',
            symbolItems: [],

            symbolCode: '',
            symbolName: '',
            
            maxRateOfReturn: '0',
            backtestDate: '',//moment().format(format),

            currSelStock: '',

            strategyData: [],

            dataSource: [],

            rowId: -1,

            backtestResult: {},
            statisticsResult: [],

            singleStockBacktestResult: [],

            selectedRowKeys: [],

            spinLoadding: true
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
    }

    init = () => {
        var { symbolCode, backtestDate, maxRateOfReturn } = this.state;

        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        /**
        var maxRateOfReturns = selRateOfReturn.filter(function (v) { return maxRateOfReturn == v.id });
        if (maxRateOfReturns.length > 0) {
            if (maxRateOfReturns[0].id == '0') {
                maxRateOfReturn = '';
            } else {
                maxRateOfReturn = maxRateOfReturns[0].name;
            }
        } else {
            maxRateOfReturn = '';
        }
        */

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_single_stock_items", payload: { t: '0', u: userId, s: symbolCode, b: backtestDate, r: maxRateOfReturn } });
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value += sign;
        }

        return value;
    }

    setBacktestResult(tmpDataSource) {
        var rowId = -1;
        var statisticsResult = [];
        var dataSource = [];
        if (tmpDataSource.length > 0) {
            for (var item in tmpDataSource) {
                if (rowId === -1) {
                    rowId = tmpDataSource[item].i;

                    if (tmpDataSource[item].statistics != null) {
                        statisticsResult = tmpDataSource[item].statistics;
                    }
                }

                var sequence = parseInt(item) + 1;

                var maxRateOfReturn = this.keepDecimals(tmpDataSource[item].mr, '');
                var maxdrawdown = this.keepDecimals(tmpDataSource[item].md, '');

                dataSource.push({
                    key: tmpDataSource[item].i,
                    sequence: sequence,
                    symbolCode: tmpDataSource[item].s,
                    created: tmpDataSource[item].c,
                    maxRateOfReturn: maxRateOfReturn,
                    maxdrawdown: maxdrawdown,
                    strategyPeriod: tmpDataSource[item].sp,
                    backtestInterval: tmpDataSource[item].bi,
                    strategyNumber: tmpDataSource[item].sn,
                    status: tmpDataSource[item].status
                });
            }
        }

        this.setState({ dataSource, rowId, statisticsResult });
    }

    componentWillReceiveProps(props) {
        var { status, symbolItems, backtestResult, symbols } = props;

        switch (status) {
            case 'get_symbol_items_success':
                if (symbolItems !== undefined && symbolItems.length > 0) {
                    this.setState({ symbolItems });
                } else {
                    if (this.state.keywords !== '') {
                        this.setState({ symbolItems: [{ symbol: '"' + this.state.keywords + '"' + languageMessages['no.matches.found'], symbolName: '' }] });
                    } else {
                        this.setState({
                            symbolItems: []
                        });
                    }
                }
                break;
            case 'get_single_stock_success':
                var currSelStock = '';
                var strategyData = [];
                for (var item in symbols) {
                    if (currSelStock === '') currSelStock = symbols[item].sc;

                    if (backtestResult.hasOwnProperty(currSelStock)) {
                        strategyData.push({
                            'id': symbols[item].i, 'stockCode': symbols[item].sc, 'stockName': symbols[item].sn
                        });
                    } else {
                        currSelStock = '';
                    }
                }

                var singleStockBacktestResult = [];
                if (currSelStock !== '') {
                    singleStockBacktestResult = backtestResult[currSelStock];
                }

                this.setState({ strategyData, currSelStock, backtestResult, singleStockBacktestResult, spinLoadding: false }, () => {
                    this.setBacktestResult(singleStockBacktestResult);
                });
                break;
            case 'get_single_stock_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_single_symbol_success':
                var currSelStock = this.state.currSelStock;
                var tmpBacktestResult = this.state.backtestResult;

                var singleStockBacktestResult = [];
                if (currSelStock !== '') {
                    singleStockBacktestResult = backtestResult[currSelStock];
                    tmpBacktestResult[currSelStock] = singleStockBacktestResult;
                }

                this.setState({ backtestResult: tmpBacktestResult, singleStockBacktestResult, spinLoadding: false }, () => {
                    this.setBacktestResult(singleStockBacktestResult);
                });
                break;
            case 'get_single_symbol_fail':
                this.setState({ spinLoadding: false });
                break;
            case 'get_remove_backtest_success':
                var currSelStock = this.state.currSelStock;
                var strategyData = this.state.strategyData;
                var tmpSymbols = symbols.filter(function (s) { return currSelStock == s.sc });
                if (tmpSymbols.length === 0) {
                    currSelStock = '';
                    strategyData = [];
                    for (var item in symbols) {
                        if (currSelStock === '') currSelStock = symbols[item].sc;

                        strategyData.push({
                            'id': symbols[item].i, 'stockCode': symbols[item].sc, 'stockName': symbols[item].sn
                        });
                    }
                }

                var singleStockBacktestResult = [];
                if (currSelStock !== '') {
                    singleStockBacktestResult = backtestResult[currSelStock];
                }
                
                this.setState({ strategyData, currSelStock, backtestResult, singleStockBacktestResult, spinLoadding: false, selectedRowKeys: [] }, () => {
                    this.setBacktestResult(singleStockBacktestResult);
                });

                message.success(languageMessages['remove.backtest.success']);

                /**
                let { dataSource, singleStockBacktestResult, rowId, statisticsResult } = this.state;

                var tmpValue = backtestIds.split(',');

                if (tmpValue.length > 0) {
                    var tmpRowKeys = tmpValue.filter(function (e) { return e === rowId.toString(); });
                    if (tmpRowKeys.length > 0) {
                        rowId = -1;
                        statisticsResult = [];
                        var tmpData = singleStockBacktestResult.filter(function (e) { return tmpValue.indexOf(e.i.toString()) === -1 });
                        if (tmpData.length > 0) {
                            rowId = tmpData[0].i;
                            if (tmpData[0].statistics != null) {
                                statisticsResult = tmpData[0].statistics;
                            }
                        }
                    }

                    dataSource = dataSource.filter(function (v) { return tmpValue.indexOf(v.key.toString()) === -1 });

                    message.success(languageMessages['remove.backtest.success']);
                }
                this.setState({ spinLoadding: false, dataSource, selectedRowKeys: [], rowId, statisticsResult });
                */
                break;
            case 'get_remove_backtest_fail':
                this.setState({ spinLoadding: false });
                break;
            default:
                break;
        }
    }

    onChangeSymbol = (symbolCode) => {
        this.setState({ symbolCode });
    }

    // 选择标的
    onSelectSymbol = value => {
        if (value !== '') {
            if (value.search(languageMessages['no.matches.found']) === -1) {
                //languageMessages['no.matches.found']

                //var symbolItems = JSON.parse(sessionStorage.getItem("SymbolItemsCache") || '[]') || [];
                //var tmpDataCode = symbolItems.filter(function (e) { return e.stockCode.toLowerCase() === value.toLowerCase(); });
                var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });

                if (tmpDataCode.length > 0) {
                    var symbolCode = tmpDataCode[0].symbol;
                    var symbolName = tmpDataCode[0].symbolName;

                    this.setState({ symbolCode, symbolName }, () => {
                        //this.setBaseInfo();
                        /**
                        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
                        if (user.username === undefined) {
                            this.props.dispatch({ type: "action_non_user" });
                        } else {
                            this.props.dispatch({ type: "action_get_stock_tick", payload: { UserId: user.username, SymbolList: symbolCode } });
                        }
                        */
                    });
                }
            }
        }
    }

    onFocusSymbol = () => {
        // defaylt symbol items
    }

    onBlurSymbol = value => {
        if (value !== '') {
            var tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.toLowerCase() === value.toLowerCase(); });
            if (tmpDataCode.length === 0) {
                tmpDataCode = this.state.symbolItems.filter(function (e) { return e.symbol.substring(2, e.symbol.length) === value; });
            }

            if (tmpDataCode.length === 1) {
                var symbolCode = tmpDataCode[0].symbol;
                var symbolName = tmpDataCode[0].symbolName;

                this.setState({ symbolCode, symbolName });
            } else {
                this.setState({
                    symbolItems: [],
                    symbolCode: '',
                    symbolName: ''
                });
            }
        } else {
            this.setState({
                symbolItems: [],
                symbolCode: '',
                symbolName: ''
            });
        }
    }

    // 匹配标的
    handleSearch = value => {
        this.setState({ keywords: value }, () => {
            /**
            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
            }
            */
            this.props.dispatch({ type: "action_get_symbol_items", payload: { UserId: this.user.username, keywords: value } });
        });
    };

    disabledBacktestDate = current => {
        return current && current > moment().endOf('day');
    }

    onChangeBacktestDate = backtestDate => {
        if (backtestDate == null) {
            backtestDate = '';
        } else {
            backtestDate = moment(backtestDate).format(format);
        }
        
        this.setState({ backtestDate });
    }

    handleIncomesChange = value => {
        this.setState({ maxRateOfReturn: value.key });
    }

    handleSelStock = symbol => {
        if (symbol !== '') {
            var { backtestResult, currSelStock, symbolCode, backtestDate, maxRateOfReturn } = this.state;

            if (symbolCode == symbol) return;
            if (currSelStock == symbol) return;

            if (backtestResult.hasOwnProperty(symbol)) {
                var singleStockBacktestResult = backtestResult[symbol];

                this.setState({ currSelStock: symbol, singleStockBacktestResult }, () => {
                    this.setBacktestResult(singleStockBacktestResult);
                });
            }else {
                this.setState({ currSelStock: symbol, spinLoadding: true }, () => {
                    var userId = this.user.username === undefined ? '' : this.user.username;
                    this.props.dispatch({ type: "action_get_single_symbol_items", payload: { t: '0', u: userId, s: symbol, b: backtestDate, r: maxRateOfReturn } });
                });
            }
        }
    }

    clearFilter = () => {
        this.setState({ symbolCode: '', symbolName: '', backtestDate: '', maxRateOfReturn: '0', spinLoadding: true }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;
            this.props.dispatch({ type: "action_get_single_stock_items", payload: { t: '0', u: userId, s: '', b: '', r: '0' } });
        });
    }

    handleSearchStockBacktest = () => {
        var { symbolCode, backtestDate, maxRateOfReturn } = this.state;

        /**
        var maxRateOfReturns = selRateOfReturn.filter(function (v) { return maxRateOfReturn == v.id });
        if (maxRateOfReturns.length > 0) {
            if (maxRateOfReturns[0].id == '0') {
                maxRateOfReturn = '';
            } else {
                maxRateOfReturn = maxRateOfReturns[0].name;
            }
        } else {
            maxRateOfReturn = '';
        }
        */

        this.setState({ spinLoadding: true }, () => {
            var userId = this.user.username === undefined ? '' : this.user.username;
            this.props.dispatch({ type: "action_get_single_stock_items", payload: { t: '0', u: userId, s: symbolCode, b: backtestDate, r: maxRateOfReturn } });
        });
    }

    importBacktestResult = (e, value) => {
        e.stopPropagation();
        console.log(value);
    }

    onRemove = () => {
        var { selectedRowKeys, currSelStock, symbolCode, backtestDate, type, maxRateOfReturn } = this.state;

        if (selectedRowKeys.length > 0) {
            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                var backtestIds = selectedRowKeys.join(',');

                var _this = this;
                Confirm({
                    title: languageMessages['want.delete.backtest'],
                    content: '',
                    okText: languageMessages['yes'],
                    okType: 'danger',
                    cancelText: languageMessages['no'],
                    onOk() {
                        _this.setState({ spinLoadding: true }, () => {
                            _this.props.dispatch({ type: "action_remove_backtest", payload: { t: type, u: _this.user.username, s: currSelStock, sc: symbolCode, b: backtestDate, bs: backtestIds, r: maxRateOfReturn } });
                        });
                    },
                    onCancel() { },
                });
            }
        }
    };

    OnSelectShowChart = (record) => {
        return {
            onClick: () => {
                const { singleStockBacktestResult, selectedRowKeys } = this.state;
                
                var tmpData = singleStockBacktestResult.filter(function (e) { return e.i === record.key; });
                if (tmpData.length > 0) {
                    var statisticsResult = [];
                    if (tmpData[0].statistics != null) {
                        statisticsResult = tmpData[0].statistics;
                    }
                    /**
                    if (selectedRowKeys.indexOf(record.key) >= 0) {
                        selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
                    } else {
                        selectedRowKeys.push(record.key);
                    }
                    */

                    this.setState({ rowId: record.key, statisticsResult, selectedRowKeys });
                }
            }
        }
    }

    setRowClassName = (record) => {
        return record.key.toString() === this.state.rowId.toString() ? 'common-table-row' : '';
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    renderStockBacktest(strategyData) {
        if (strategyData.length > 0) {
            return <List size={"small"}
                dataSource={this.state.strategyData}
                renderItem={item => (
                    <List.Item key={item.id} onClick={() => this.handleSelStock(item.stockCode)} className={this.state.currSelStock == item.stockCode ? 'checked' : ''}>
                        <List.Item.Meta
                            title={(<span style={{ fontWeight: '100' }}>{item.stockName}</span>)}
                            description={(<b>{item.stockCode}</b>)}
                        />
                    </List.Item>
                )}
            />
        } else {
            return <div style={{ textAlign: 'center', padding: '20px 0', color: 'rgba(100, 100, 100, 0.75' }}>{languageMessages['not']}</div>
        }
    }

    render() {
        var { strategyData, symbolItems, symbolCode, dataSource, selectedRowKeys } = this.state;

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'center',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolCode',
                width: 90,
                //sorter: (a, b) => a.symbolCode < b.symbolCode ? -1 : a.symbolCode > b.symbolCode ? 1 : 0,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['created'],
                dataIndex: 'created',
                width: 135,
                //sorter: (a, b) => a.created - b.created,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['maxRateOfReturn']+'(%)',
                dataIndex: 'maxRateOfReturn',
                width: 140,
                align: 'center',
                sorter: (a, b) => a.maxRateOfReturn - b.maxRateOfReturn,
                sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['maxRateOfReturn'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['maxdrawdown']+'(%)',
                dataIndex: 'maxdrawdown',
                width: 105,
                align: 'center',
                sorter: (a, b) => a.maxdrawdown - b.maxdrawdown,
                sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['maxdrawdown'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['strategyPeriod'],
                dataIndex: 'strategyPeriod',
                width: 90,
                sorter: (a, b) => a.strategyPeriod - b.strategyPeriod,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['backtestInterval'],
                dataIndex: 'backtestInterval',
                width: 155,
            }, {
                title: languageMessages['strategyNumber'],
                dataIndex: 'strategyNumber',
                width: 90,
                align: 'center',
                sorter: (a, b) => a.strategyNumber - b.strategyNumber,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['status'],
                dataIndex: 'status',
                width: 60,
                sorter: (a, b) => a.status - b.status,
                sortDirections: ['descend', 'ascend'],
                render: status => (
                    <span>
                        {status == 0 ? languageMessages['backtesting'] : languageMessages['complete']}
                    </span>
                )
            }
        ];

        if (symbolCode.search(languageMessages['no.matches.found']) !== -1) {
            symbolCode = symbolCode.replace(languageMessages['no.matches.found'], '');
            symbolCode = symbolCode.substring(1, symbolCode.length - 1);
        }

        const rowSelection = {
            title: languageMessages['select.all'],
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectChange
        }
        
        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
            <div className='common-page-header'>
                <PageHeader title={(<h1>{languageMessages['myExcavate'] + ' » ' + languageMessages['strategyExcavate']}</h1>)} />
            </div>
            <div style={{ padding: '0px 50px' }}>
                <div className='common-title'><Divider type="vertical" />{languageMessages['backtestFilter']}</div>
                <div style={{ padding: '10px 0' }}>
                    <div className='common-panel'>
                        <label className='common-label-cn'>{languageMessages['symbolCode']}</label>
                        <AutoComplete value={symbolCode}
                            className="certain-category-search"
                            dropdownClassName="certain-category-search-dropdown"
                            dropdownMatchSelectWidth={false}
                            dropdownStyle={{ width: 200 }}
                            size="small"
                            style={{ width: '200px' }}
                            dataSource={symbolItems.map(group => (
                                <Option key={group.symbol} value={group.symbol}>
                                    {group.symbol}
                                    <span className="certain-search-item-count">{group.symbolName}</span>
                                </Option>
                            ))}
                            onChange={this.onChangeSymbol}
                            onSearch={this.handleSearch}
                            onSelect={this.onSelectSymbol}
                            onFocus={this.onFocusSymbol}
                            onBlur={this.onBlurSymbol}
                            placeholder={languageMessages['pleaseEnterSymbolCode']}
                            optionLabelProp="value">
                            <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                        </AutoComplete>
                    </div>
                    <div className='common-panel'>
                        <label className='common-label-cn'>{languageMessages['backtestTime']}</label>
                        <DatePicker size="small"
                                format={format} allowClear={false}
                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                disabledDate={this.disabledBacktestDate}
                                placeholder={'0000-00-00 00:00:00'}
                                value={this.state.backtestDate == '' ? null : moment(this.state.backtestDate)}
                                //defaultValue={moment(this.state.backtestDate)}
                            style={{ width: '150px' }}
                            onChange={this.onChangeBacktestDate}
                        />
                    </div>
                    <div className='common-panel'>
                        <label className='common-label-cn'>{languageMessages['annualizedRateOfReturn']}</label>
                        <Select labelInValue size='small' value={{ key: this.state.maxRateOfReturn }} style={{ width: '120px' }} onChange={this.handleIncomesChange}>
                            {
                                selRateOfReturn.map(item => (
                                    <Option key={item.id}>{item.name}</Option>
                                ))
                            }
                        </Select>
                    </div>
                    <div style={{ float: 'right' }}>
                        <Button onClick={this.handleSearchStockBacktest}>{languageMessages['search']}</Button>
                        <Button style={{ marginLeft: '10px' }} onClick={this.clearFilter}>{languageMessages['clearFilter']}</Button>
                    </div>
                </div>
                
                <Layout className='backtest-content'>
                    <Sider width={280}>
                        <div className='common-sider-header'>{languageMessages['symbolName&Code']}</div>
                        <Divider />
                        {this.renderStockBacktest(strategyData)}
                    </Sider>
                    <div className='common-content'>
                        <div className='common-tools'>
                            <Button onClick={this.onRemove} disabled={selectedRowKeys.length > 0 ? false : true}>{languageMessages['remove']}</Button>
                        </div>
                        <Table size='middle' locale={{ emptyText: ' ' }}
                            columns={columns}
                            dataSource={dataSource}
                            rowSelection={rowSelection}
                            onRow={this.OnSelectShowChart}
                            rowClassName={this.setRowClassName}
                            pagination={false} scroll={{ y: 331 }} />
                    </div>
                </Layout>
            </div>
            <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                {this.state.statisticsResult.length == 0 || (<BacktestResult dispatch={this.props.dispatch} statisticsResult={this.state.statisticsResult} />)}
            </Content>
        </Spin>
    </Content>);
    }
}

function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(MyBacktestPage);
export { page as default }